/**
 * inCust API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CustomerBenefitsApiModel } from './customer-benefits';

export interface ReferralProgramChainNodeApiModel {
  /**
   * Invitation accepted
   */
  invitation_accepted?: boolean | null;
  /**
   * Invitation accepted date and time
   */
  invitation_accepted_dt?: string | null;
  /**
   * Invitation confirmed by sale transaction
   */
  invitation_confirmed?: boolean | null;
  /**
   * Invitation confirmed by sale transaction
   */
  invitation_confirmed_dt?: string | null;
  /**
   * Level number (optional)
   */
  level?: number | null;
  referrals?: Array<ReferralProgramChainNodeApiModel> | null;
  /**
   * Referrer User ID
   */
  referrer_user_id?: string | null;
  rewards?: CustomerBenefitsApiModel;
  /**
   * Type
   */
  type?: ReferralProgramChainNodeApiModelTypeEnum | null;
  /**
   * User email
   */
  user_email?: string | null;
  /**
   * User external id (optional, if platform support)
   */
  user_external_id?: string | null;
  /**
   * User ID
   */
  user_id?: string | null;
  /**
   * User name
   */
  user_name?: string | null;
  /**
   * User phone number
   */
  user_phone?: string | null;
}
export enum ReferralProgramChainNodeApiModelTypeEnum {
  Referrer = 'referrer',
  Referral = 'referral'
}
